import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWriting: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconWriting"><Path d="M18 1.58569L11 8.58569V12.9999L15.4142 12.9999L22.4142 5.99983L18 1.58569Z" fill="currentColor"/><Path d="M6 11C4.34315 11 3 12.3431 3 14C3 15.6569 4.34315 17 6 17H16C16.5523 17 17 17.4477 17 18C17 18.5523 16.5523 19 16 19H11V21H16C17.6569 21 19 19.6569 19 18C19 16.3431 17.6569 15 16 15H6C5.44772 15 5 14.5523 5 14C5 13.4477 5.44772 13 6 13H9V11H6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWriting;
